import ACTIONS from 'state/constants';

const setCollectionPageData =
  ({ data }) =>
  dispatch => {
    dispatch({
      type: ACTIONS.SET_COLLECTION_PAGE_DATA,
      payload: { data },
    });
  };

const initCollectionPageFilters =
  ({ urlParams }) =>
  dispatch =>
    dispatch({
      type: ACTIONS.INIT_COLLECTION_PAGE_FILTERS,
      payload: { urlParams },
    });

const setCollectionPageFilter =
  ({ filterIdentifier, option, value }) =>
  dispatch =>
    dispatch({
      type: ACTIONS.SET_COLLECTION_PAGE_FILTER,
      payload: { filterIdentifier, option, value },
    });

const expandCollectionPageFilter =
  ({ filterIdentifier }) =>
  dispatch =>
    dispatch({
      type: ACTIONS.EXPAND_COLLECTION_PAGE_FILTER,
      payload: { filterIdentifier },
    });

const clearCollectionPageFilters = () => dispatch =>
  dispatch({
    type: ACTIONS.CLEAR_COLLECTION_PAGE_FILTERS,
  });

const openCollectionPageFilterDrawer = () => dispatch =>
  dispatch({
    type: ACTIONS.OPEN_COLLECTION_PAGE_FILTER_DRAWER,
  });

const closeCollectionPageFilterDrawer = () => dispatch =>
  dispatch({
    type: ACTIONS.CLOSE_COLLECTION_PAGE_FILTER_DRAWER,
  });

const setCollectionPageStructuredData =
  ({ faqItems, description, name }) =>
  dispatch => {
    dispatch({
      type: ACTIONS.SET_COLLECTION_STRUCTURED_DATA,
      payload: { faqItems, description, name },
    });
  };

export {
  setCollectionPageData,
  initCollectionPageFilters,
  setCollectionPageFilter,
  expandCollectionPageFilter,
  clearCollectionPageFilters,
  openCollectionPageFilterDrawer,
  closeCollectionPageFilterDrawer,
  setCollectionPageStructuredData,
};
